import React from 'react';
import { Textarea, Button } from 'components';
import { connect } from 'react-redux';
import { SurveyService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router';
import { Logo } from 'assets/img';
import { 
	ArrowLeft, 
	LockIcon, 
	InstagramSurveyIcon, 
	WhatsappSurveyIcon, 
	EmailIcon,
	Survey1Icon,
	Survey2Icon,
	Survey3Icon,
	Survey4Icon,
	Survey5Icon,
	Survey6Icon,
	CheckWhiteIcon
} from 'assets/icons';
import { Globals } from 'utils';
import queryString from 'query-string';

interface Props extends RouteComponentProps<any> {
	dispatch: any
}

class Survey extends React.Component<Props> {

	state = {
		visible: false,
		survey: null,
		titles: [],
		contact_info: null,
		form: {
			comments: ''
		},
		values_array: []
	}

	async componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Control de Calidad y Servicio',
				onBack: null
			}
		});

		let values_array = [];
		for (let i = 1; i <= 6; i++) {
			let icon = '';

			switch(i) {
				case 1:
					icon = Survey1Icon;
				break;

				case 2:
					icon = Survey2Icon;
				break;

				case 3:
					icon = Survey3Icon;
				break;

				case 4:
					icon = Survey4Icon;
				break;

				case 5:
					icon = Survey5Icon;
				break;

				case 6:
					icon = Survey6Icon;
				break;
			}

			values_array.push({
				value: i,
				icon
			});
		}

		await this.setState({
			values_array
		});
		
		const res: any = await SurveyService.check({
			code: this.props.match.params.code
		});
		if (!res.survey) {
			this.props.history.replace('/');
		}
		else {
			this.setState({
				visible: true,
				survey: res.survey,
				titles: res.titles || [],
				contact_info: res.contact_info
			});
		}
	}

	submit = async () => {
		for (let i = 0; i < this.state.titles.length; i++) {
			const item: any = this.state.titles[i];

			if (item.subtitles.length > 0) {
				for (let j = 0; j < item.subtitles.length; j++) {
					if (!item.subtitles[j].value) {
						Globals.showError(`Por favor, puntué el apartado de "${ item.subtitles[j].name }"`);
						return;
					}
				}
			}
		}

		await SurveyService.save({
			// @ts-ignore
			survey_id: this.state.survey?.id,
			responses: JSON.stringify(this.state.titles),
			...this.state.form
		});
		
		setTimeout(() => {
			const params = queryString.parse(this.props.location.search);
			if (params?.return_to_quotes) {
				this.props.history.replace('/client/quotes/request/' + params?.return_to_quotes);
			}
			else {
				this.props.history.replace('/');
			}
			Globals.showSuccess("¡Gracias por darnos su opinión!");
		},500);
	}

	changeValue = (e: any, title_index: number, index: number) => {
		let titles = [...this.state.titles];
		// @ts-ignore
		titles[title_index][e.target.name][index].value = e.target.value;
		this.setState({
			titles
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		const contact_info: any = this.state.contact_info;
		const survey: any = this.state.survey;
		const values_array: any = this.state.values_array;

		return (
			<div id="survey">
				{
					this.state.visible && (
						<div className="container-survey">
							<div className="text-center">
								<img src={ Logo } className="logo" />
							</div>
							<p className="code">Nº de Control: { survey?.quote?.number }</p>
							<h3>Control de calidad y servicio</h3>
							<div className="container-title">
								<h4>Datos del cliente</h4>
								<div>
									<p className="value"><strong>Nombre:</strong> { survey?.quote?.user?.full_name }</p>
									<p className="value"><strong>Dirección del servicio:</strong> { survey?.quote?.address }</p>
									<p className="value"><strong>Tipo de servicio:</strong> { survey?.quote?.type?.name }</p>
								</div>
							</div>
							<div className="container-title">
								<h4>Datos de los talentos en limpieza</h4>
								<div>
									{
										survey?.quote?.operators?.map((item: any) => {
											return (
												<div className="row item-operator">
													<div className="col-md-7">
														<p className="value"><strong>Nombre:</strong> { item?.operator?.full_name }</p>
													</div>
													<div className="col-md-5">
														<p className="value"><strong>Nº CI:</strong> { item?.operator?.full_document }</p>
													</div>
												</div>
											)
										})
									}
								</div>
							</div>
							{
								this.state.titles.map((item: any, title_index: number) => {
									return (
										<div className="container-title">
											<h4>{ item.name }</h4>
											{
												item?.subtitles.length > 0 && (
													<>
														<table style={{ width: '100%' }}>
															<tr>
																<td style={{ width: '40%' }}>
																	<p className="value-subtitle"></p>
																</td>
																{
																	values_array.map((item: any) => {
																		return (
																			<td style={{ width: '10%' }} className="text-center">
																				<img src={ item.icon } className="survey-icon" />
																			</td>
																		)
																	})
																}
															</tr>
															{
																item?.subtitles?.map((subtitle: any, index: number) => {
																	return (
																		<tr>
																			<td style={{ width: '40%' }}>
																				<p className="value-subtitle">{ subtitle?.name }</p>
																			</td>
																			{
																				values_array.map((item: any) => {
																					return (
																						<td style={{ width: '10%' }} className="text-center">
																							<div className={ `check ${ subtitle.value == item.value ? 'active' : '' }` } onClick={ () => this.changeValue({
																								target: {
																									name: 'subtitles',
																									value: subtitle.value == item.value ? null : item.value
																								}
																							},title_index,index) }>
																								{
																									subtitle.value == item.value && (
																										<img src={ CheckWhiteIcon } />
																									)
																								}
																							</div>
																						</td>
																					)
																				})
																			}
																		</tr>
																	)
																})
															}
														</table>
													</>
												)
											}
											{
												item?.questions?.length > 0 && (
													<div>
														<div className="row">
															{
																item?.questions.map((question: any, index: number) => {
																	return (
																		<>
																			<div className="col-md-6">
																				<p className="value-question">{ question?.name }</p>
																			</div>
																			<div className="col-md-6">
																				<Textarea
																					rows={ 2 }
																					color="white"
																					value={ question?.value }
																					name="questions"
																					onChange={ (e: any) => this.changeValue(e,title_index,index) } />
																			</div>
																		</>
																	)
																})
															}
														</div>
													</div>
												)
											}
										</div>
									)
								})
							}
							<div className="container-title">
								<h4>Observaciones</h4>
								<div>
									<Textarea
										rows={ 4 }
										color="white"
										value={ this.state.form.comments }
										name="comments"
										onChange={ this.change } />
								</div>
							</div>
							<div className="text-center">
								<Button type="submit" className="btn-green" onClick={ () => this.submit() }>
									Guardar
								</Button>
							</div>
							<div className="row">
								<div className="col-md-4">
									<p className="footer">
										<img src={ WhatsappSurveyIcon } className="info-icon" />
										{ contact_info?.whatsapp }
									</p>
								</div>
								<div className="col-md-4">
									<p className="footer">
										<img src={ InstagramSurveyIcon } className="info-icon" />
										{ contact_info?.instagram.replace('https://www.instagram.com/','@').replace('/','') }
									</p>
								</div>
								<div className="col-md-4">
									<p className="footer">
										<img src={ EmailIcon } className="info-icon" />
										{ contact_info?.email }
									</p>
								</div>
							</div>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Survey);